/**
 * Homepage interactive setup walkthrough — wizard screenshots bundled like platformUiScreenshotSlots.
 *
 * Previews use object-fit: contain so the full screenshot stays visible. For tight “hero crops,”
 * export tighter PNGs from design rather than CSS zoom/crop.
 */
import sync1Png from '../assets/screenshots/sync1.png';
import sync2Png from '../assets/screenshots/sync2.png';
import sync3Png from '../assets/screenshots/sync3.png';
import sync4Png from '../assets/screenshots/sync4.png';
import sync5Png from '../assets/screenshots/sync5.png';

/** Outcome-led copy + live hints for the preview overlay */
export const HOME_SETUP_WALKTHROUGH_STEPS = [
    {
        id: 'connect',
        tabLabel: 'Connect',
        title: 'Connect your apps',
        benefit: 'Connect the apps your team already uses.',
        imageSrc: sync1Png,
        imageAlt: 'Connect apps: search and pick from connector cards.',
        liveHint: '120+ connectors · browse live',
    },
    {
        id: 'select-data',
        tabLabel: 'Select data',
        title: 'Choose what matters',
        benefit: 'Pick the reports and data you care about.',
        imageSrc: sync2Png,
        imageAlt: 'Select data: objects, filters, and fields.',
        liveHint: 'Pick fields · preview updates live',
    },
    {
        id: 'destination',
        tabLabel: 'Send to',
        title: 'Choose where reports update',
        benefit: 'Send updates to spreadsheets, dashboards, and databases.',
        imageSrc: sync3Png,
        imageAlt: 'Destination: connected account and where data lands.',
        liveHint: 'Destination connected · ready to route',
    },
    {
        id: 'configure',
        tabLabel: 'Configure',
        title: 'Organize how your team sees it',
        benefit: 'Organize how your team sees the data.',
        imageSrc: sync4Png,
        imageAlt: 'Configure mapping and options before running the sync.',
        liveHint: 'Mapping saved · no engineering ticket',
    },
    {
        id: 'start',
        tabLabel: 'Start',
        title: 'Review & go live',
        benefit: 'Turn it on and keep reports updated automatically.',
        imageSrc: sync5Png,
        imageAlt: 'Review schedule and settings, then start the sync.',
        liveHint: 'Schedule on · updates run automatically',
    },
];
